export const ROLES = ['lead', 'customer', 'worker', 'manager', 'admin'] as const
export type Role = (typeof ROLES)[number]

export const ROLE_LABELS: Record<Role, string> = {
  lead: 'Lead',
  customer: 'Customer',
  worker: 'Worker',
  manager: 'Manager',
  admin: 'Admin',
}

export function canManage(role: string): boolean {
  return ['lead', 'manager', 'admin'].includes(role)
}

export function canCreate(role: string): boolean {
  return ['lead', 'worker', 'manager', 'admin'].includes(role)
}

export function isAdmin(role: string): boolean {
  return role === 'admin'
}

export const PHASES = [
  'idea',
  'viability',
  'building',
  'marketing',
  'live',
  'scaling',
  'archived',
] as const
export type Phase = (typeof PHASES)[number]

export const PHASE_LABELS: Record<Phase, string> = {
  idea: 'Idea',
  viability: 'Viability',
  building: 'Building',
  marketing: 'Marketing',
  live: 'Live',
  scaling: 'Scaling',
  archived: 'Archived',
}

export const PHASE_COLORS: Record<Phase, string> = {
  idea: 'bg-phase-idea',
  viability: 'bg-phase-viability',
  building: 'bg-phase-building',
  marketing: 'bg-phase-marketing',
  live: 'bg-phase-live',
  scaling: 'bg-phase-scaling',
  archived: 'bg-phase-archived',
}
